export function getToasts(state) {
	return state.getIn(["toasts"]);
}
